/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/WizardStepScope.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const WizardStepScopeTestIds = {
  btnScopeModeConditions: "btn-scope-mode-conditions",
  btnScopeModeExpression: "btn-scope-mode-expression",
  dialogSwitchMode: "dialog-switch-mode",
  expressionEditor: "expression-editor",
  expressionErrorBanner: "expression-error-banner",
  previewSection: "preview-section",
  scopeCard: "scope-card",
  scopeConditionsLabel: "scope-conditions-label",
  scopeExpressionLabel: "scope-expression-label",
  scopeModeToggle: "scope-mode-toggle"
} as const;
